import React from 'react';
import { TimePicker } from 'antd';
import { format } from 'date-fns';
import moment from 'moment';
import 'antd/dist/antd.min.css';
import { useFormikContext } from 'formik';
import styles from './DirectorSettings.module.scss';

const formatDate = 'HH:mm';

type Props = {
  name: string;
  value: any;
};

const Picker: React.FC<Props> = ({ name, value }) => {
  const { setFieldValue } = useFormikContext();
  return (
    <TimePicker
      className={styles.picker}
      name={name}
      minuteStep={name === 'autoApproveTime' ? 30 : 15}
      // @ts-ignore
      onChange={(dateString: string) => setFieldValue(`${name}`, dateString)}
      defaultValue={typeof value !== 'string' ? value : moment(format(Date.parse(value), 'HH:mm'), formatDate)}
      format={formatDate}
      inputReadOnly
    />
  );
};
export default Picker;
